/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/1/22, 3:54 PM
 *
 */

import QRCode from 'react-qr-code';
import { Member, MemberOtherDetails } from 'types/MemberTypes';
import { epochToDate } from 'utils/epochToDate';

interface IProfileOverviewTabProps {
  other_details: MemberOtherDetails[];
  primary_details: Member;
}

/**
 * @param {Member} primary_details - basic details included in each member. These values are strictly compulsory.
 * @param {MemberOtherDetails} other_details - other details that are not required on not included in primary details
 * @return {JSX.Element}
 */
export default function MemberProfileOverviewTab({
  other_details,
  primary_details,
}: IProfileOverviewTabProps) {
  console.log({ primary_details: primary_details.role.slug === 'school_student' });
  return (
    <div className="relative flex w-full flex-col rounded-2xl bg-white p-8 shadow-sm">
      <h1 className="text-3xl font-medium text-gray-800">Profile Overview</h1>
      <div className="absolute left-0 top-20 h-0.5 w-full bg-slate-200" />
      <div className="flex w-full">
        <div className="mt-12 flex w-4/5 flex-col">
          <div className="flex w-full gap-4 md:w-full">
            <div className="flex w-1/6 flex-col gap-8 sm:w-1/2">
              <div className="text-xl font-medium text-gray-400">Member Code</div>
              <div className="text-xl font-medium text-gray-400">Full Name</div>
              <div className="text-xl font-medium text-gray-400">Email Address</div>
              <div className="text-xl font-medium text-gray-400">Phone Number</div>
              <div className="text-xl font-medium text-gray-400">Date of Birth</div>
              <div className="text-xl font-medium text-gray-400">Age</div>
              <div className="text-xl font-medium text-gray-400">Address</div>
              <div className="text-xl font-medium text-gray-400">Gender</div>
              <div className="text-xl font-medium text-gray-400">Marital Status</div>
              {other_details.map((detail) => (
                <div key={detail.id} className="text-xl font-medium text-gray-400">
                  {detail.name}
                </div>
              ))}
            </div>
            <div className="flex w-5/6 flex-col gap-8 sm:w-1/2">
              <div className="font-Inter text-xl font-medium text-gray-800 line-clamp-1">
                {primary_details.member_code || 'N/A'}
              </div>
              <div className="text-xl font-medium text-gray-800 line-clamp-1">
                {primary_details.name || 'N/A'}
              </div>
              <a
                href={`mailto: ${primary_details.email}`}
                className="text-xl font-medium text-gray-800 line-clamp-1"
              >
                {primary_details.email ? primary_details.email : 'N/A'}
              </a>
              <a
                href={`tel: ${primary_details.phone}`}
                className="text-xl font-medium text-gray-850 line-clamp-1"
              >
                {primary_details.phone ? `+977-${primary_details.phone}` : 'N/A'}
              </a>
              <div className="text-xl font-medium text-gray-850 line-clamp-1">
                {primary_details.dob_ad ? epochToDate(primary_details.dob_ad) : 'N/A'}
              </div>
              <div className="text-xl font-medium text-gray-850 line-clamp-1">
                {primary_details?.age ?? 0} years
              </div>
              <div className="text-xl font-medium text-gray-850">
                {primary_details.address || 'N/A'}
              </div>
              <div className="text-xl font-medium text-gray-850 line-clamp-1">
                {primary_details.gender || 'N/A'}
              </div>

              <div className="text-xl font-medium text-gray-850 line-clamp-1">
                {primary_details.role.slug === 'school_student'
                  ? 'Single'
                  : primary_details.marital_status || 'N/A'}
              </div>
              {other_details.map((detail) => (
                <div key={detail.id} className="text-xl font-medium text-gray-850 line-clamp-1">
                  {detail.value || 'N/A'}
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="mt-20">
          <QRCode size={180} value={primary_details.id.toString()} />
        </div>
      </div>
    </div>
  );
}
